import React from "react";
import "./Footer.css";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaFacebookF,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import { Link } from "react-router-dom";

function Footer() {
  const { t } = useTranslation();
  return (
    <div className="footer ">
      <div className="overlay">
        <Container>
          <div className="footer-bottom">
            <Row>
              <Col xs={12}>
                <div className="social-main  mt-4">
                  <ul className="social-icons">
                    <Link to="https://x.com/KalemonAcademy" target="_blank">
                      <li> <FaXTwitter className="social-icon " /> </li>
                    </Link>
                    <Link to="https://www.youtube.com/@KalemonAcademy" target="_blank">
                      <li> <FaYoutube className="social-icon  linkdin" /> </li>
                    </Link>
                    <Link to="https://www.instagram.com/kalemonacademy" target="_blank">
                      <li> <FaInstagram className="social-icon insta " /> </li>
                    </Link>
                    <Link to="https://www.facebook.com/KalemonAcademy" target="_blank">
                      <li> <FaFacebookF className="social-icon face" /> </li>
                    </Link>
                  </ul>
                </div>
              </Col>
              <div className="">
                <Col xs={12}>
                  <div className="links-main mb-2">
                    <div className="links-conttent d-flex justify-content-center align-items-center flex-wrap">
                      <Link to="/">
                        <h5> {t("about Kalemon Academy")} </h5>
                      </Link>
                      <Link to="/">
                        <h5> {t("Latest news")} </h5>
                      </Link>
                      <Link to="/contact-us">
                        <h5> {t("contact-us")} </h5>
                      </Link>
                      <Link to="/">
                        <h5> {t("Technical support")} </h5>
                      </Link>
                      <Link to="/">
                        <h5> {t("Privacy policy")} </h5>
                      </Link>


                    </div>
                  </div>


                </Col>

              </div>
            </Row>

            <p> {t("All Rights Reserved")} &copy; Kalemon 2025 </p>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default Footer;

